export const queryKeys = {
  authProfile: ['auth', 'profile'] as const,
  machines: (customerId: string | null, search: string, status: 'ACTIVE' | 'ARCHIVED' = 'ACTIVE') =>
    ['machines', customerId, status, search] as const,
  documents: (customerId: string | null, machineId: string, lifecycleStatus?: 'ACTIVE' | 'REMOVED') =>
    lifecycleStatus
      ? ['documents', customerId, machineId, lifecycleStatus] as const
      : ['documents', customerId, machineId] as const,
  document: (customerId: string | null, documentId: string) =>
    ['document', customerId, documentId] as const,
  imageEvidence: (customerId: string | null, documentId: string) =>
    ['image-evidence', customerId, documentId] as const,
  conversations: (customerId: string | null, machineId: string) =>
    ['conversations', customerId, machineId] as const,
  conversation: (customerId: string | null, conversationId: string) =>
    ['conversation', customerId, conversationId] as const,
  investigations: (customerId: string | null, machineId: string) =>
    ['investigations', customerId, machineId] as const,
  investigation: (customerId: string | null, investigationId: string) =>
    ['investigation', customerId, investigationId] as const,
  investigationReasoningV1: (customerId: string | null, investigationId: string) =>
    ['investigation-reasoning-v1', customerId, investigationId] as const,
  investigationReasoning: (customerId: string | null, investigationId: string) =>
    ['investigation-reasoning', customerId, investigationId] as const,
  investigationReasoningFreshness: (customerId: string | null, investigationId: string) =>
    ['investigation-reasoning-freshness', customerId, investigationId] as const,
  investigationInquiries: (customerId: string | null, investigationId: string) =>
    ['investigation-inquiries', customerId, investigationId] as const,
  investigationReasoningHistory: (customerId: string | null, investigationId: string) =>
    ['investigation-reasoning-history', customerId, investigationId] as const,
  notifications: (customerId: string | null) => ['notifications', customerId] as const,
  machineMemory: (customerId: string | null, machineId: string) =>
    ['machine-memory', customerId, machineId] as const,
  activity: (customerId: string | null, machineId: string, category: string) =>
    ['activity', customerId, machineId, category] as const,
  users: (customerId: string | null) => ['users', customerId] as const,
  facilities: (customerId: string | null) => ['facilities', customerId] as const,
  billing: (customerId: string | null) => ['billing', customerId] as const,
};
